<template>
    <Table :columns="column" :data="swiperSlides" border stripe style="margin-top:5px;">
      <template slot-scope="{ row }" slot="status">
        <span v-if="row.agree === '1'" style="color: green"><Icon type="ios-time" />通过</span>
        <span v-if="row.agree === '0'" style="color: #ed4014"><Icon type="ios-time" />驳回</span>
        <span v-if="row.agree === ''"><Icon type="ios-time-outline"/>待审核</span>
      </template>
      <template slot-scope="{ row }" slot="time">
        <span >{{row.endTime}}</span>
      </template>
    </Table>
</template>

<script>
export default {
  props: {
    // 传入的文件信息
    swiperSlides: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      column: [
        {
          title: '审批节点',
          key: 'taskName',
          width: 150
        },
        {
          title: '审批状态',
          slot: 'status',
          width: 150
        },
        {
          title: '审批时间',
          key: 'endTime',
          slot: 'time',
          width: 150
        },
        {
          title: '审批人',
          key: 'userName',
          width: 150
        },
        {
          title: '审批意见',
          key: 'message',
          width: 400
        }
      ]
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/printSwiperSlidesTable/src/printTable.vue